import * as React from 'react'
import EnrollmentPathway from './EnrollmentPathway'

function EnrollmentPathwayRecommended(props) {
  return <EnrollmentPathway {...props} type="recommended" />
}

export default EnrollmentPathwayRecommended
